<template>
  <section class="bootcamp-meta">
    <div class="meta-container">
      <MetaSection
        v-for="meta in info"
        :key="meta.label"
        :label="meta.label"
        :title="meta.title"
        :description="meta.description"
      />
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  components: {
    MetaSection: () => import("@/components/bootcamp/enroll/meta/MetaSection"),
  },
  computed: {
    ...mapGetters("BootcampEnroll", ["bootcampInfoByKey"]),
    key () {
      return this.$route.params.key || this.$route.path.replace("/", "")
    },
    info () {
      return this.bootcampInfoByKey(this.key)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
.bootcamp-meta {
  background: #ffffff;
  .meta-container {
    width: 100%;
    max-width: 140.5rem;
    padding: 4.5rem 0;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    @include phone-down {
      grid-template-columns: 1fr;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bootcamp/enroll/meta/TheBootcampMeta.vue